const PeriodMap: { [key: number]: string } = {
    1: "自定日期區間",
    2: "近一週",
    3: "近一個月",
};

const TransactionMap: { [key: number]: string } = {
    1: "購貨",
    2: "退貨",
};

const NoteMap: { [key: number]: string } = {
    0: "業務註記",
    1: "分期-I/TWQR-G",
    2: "定額註記",
    3: "電支跨機構交易註記",
    4: "台灣PayQRcode註記",
};

const AppropriationNoteMap: { [key: number]: string } = {
    0: "業務註記",
    1: "分期-I/TWQR-G",
    2: "定額註記",
    4: "台灣PayQRcode註記",
};

const CardMap: { [key: number]: string } = {
    1: "VISA",
    2: "Master",
    3: "JCB",
    4: "金融卡",
    5: "銀聯卡",
};

const SaleKindMap: { [key: number]: string } = {
    1: "一般收單",
    2: "跨境收單",
};

const TypeFlagMap: { [key: number]: string } = {
    1: "C",
    2: "F",
};

export const Reconciliation = {
    PeriodMap,
    TransactionMap,
    NoteMap,
    AppropriationNoteMap,
    CardMap,
    SaleKindMap,
    TypeFlagMap,
};
